// extracted by mini-css-extract-plugin
module.exports = {"promoAddOn":"PromoAddOn_promoAddOn__1z8kf","promoAddOnSizeBox":"PromoAddOn_promoAddOnSizeBox__1yH9h"};